import React from "react";
import { Box, Container, Grid, Typography, Paper } from "@mui/material";
import CountUp from "react-countup";

const stats = [
  { value: 20, label: "Residential Projects", suffix: "+" },
  { value: 200, label: "Happy Customers", suffix: "+" },
  { value: 10, label: "Active Projects", suffix: "+" },
];

const OurSuccess = () => {
  return (
    <Box
      sx={{
        py: { xs: 8, md: 10 },
        background: "linear-gradient(180deg, #f9f9f9 0%, #f3f8f6 100%)",
      }}
    >
      <Container maxWidth="lg">
        {/* Heading */}
        <Typography
          variant="h3"
          sx={{
            textAlign: "center",
            fontWeight: 800,
            letterSpacing: "1px",
            mb: { xs: 5, md: 8 },
            background: "linear-gradient(90deg, #018f87, rgba(2, 65, 54, 1))",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontSize: { xs: "28px", md: "40px" },
          }}
        >
          OUR SUCCESS
        </Typography>

        {/* Stats */}
        <Grid
          container
          spacing={{ xs: 3, md: 5 }}
          justifyContent="center"
          alignItems="stretch"
        >
          {stats.map((stat, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Paper
                elevation={3}
                sx={{
                  textAlign: "center",
                  p: { xs: 4, md: 5 },
                  borderRadius: "20px",
                  backgroundColor: "#fff",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-10px)",
                    boxShadow: "0 12px 30px rgba(0, 0, 0, 0.12)",
                  },
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: 900,
                    background: "linear-gradient(90deg, #018f87, #037e78ff)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    fontSize: { xs: "44px", md: "60px" },
                    mb: 1,
                  }}
                >
                  <CountUp end={stat.value} duration={2.5} />{stat.suffix}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    color: "#444",
                    letterSpacing: "1px",
                    fontSize: { xs: "15px", md: "17px" },
                    textTransform: "uppercase",
                    fontWeight: 600,
                  }}
                >
                  {stat.label}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default OurSuccess;
